"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoanApplicationComplete = void 0;
var doshx_controls_web_1 = require("doshx_controls_web");
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var colors_config_1 = __importDefault(require("../../../../../colors.config"));
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
var get_app_1 = require("../../home/components/get_app");
var checkout_1 = require("../../../../api/calls/basket/checkout");
var application_1 = require("../../../../api/calls/loan/application");
var LoanApplicationComplete = function () {
    var dispatch = (0, react_redux_1.useDispatch)();
    var navigate = (0, react_router_dom_1.useNavigate)();
    var basket = (0, react_redux_1.useSelector)(function (state) { return state.basketState; }).basket;
    var params = (0, react_router_dom_1.useParams)();
    var loan_id = params.loan_id;
    var _a = (0, react_1.useState)(true), isLoading = _a[0], setIsLoading = _a[1];
    (0, react_1.useEffect)(function () {
        if (basket) {
            saveLoanDetails();
        }
        else {
            // navigate("/loan/details" + "/" + loan_id);
            setIsLoading(false);
        }
    }, [basket]);
    var saveLoanDetails = function () { return __awaiter(void 0, void 0, void 0, function () {
        var checkoutBasket;
        var _a, _b, _c, _d, _e, _f;
        return __generator(this, function (_g) {
            switch (_g.label) {
                case 0:
                    setIsLoading(true);
                    console.log("Basket", basket);
                    return [4 /*yield*/, (0, checkout_1.checkout_basket)({
                            _id: basket === null || basket === void 0 ? void 0 : basket._id,
                            loan_amount: basket === null || basket === void 0 ? void 0 : basket.total,
                        })];
                case 1:
                    checkoutBasket = _g.sent();
                    console.log("checkoutBasket", checkoutBasket);
                    if (!checkoutBasket.success) return [3 /*break*/, 3];
                    return [4 /*yield*/, (0, application_1.update_loan_application)({
                            order_id: (_c = (_b = (_a = checkoutBasket === null || checkoutBasket === void 0 ? void 0 : checkoutBasket.content) === null || _a === void 0 ? void 0 : _a.order) === null || _b === void 0 ? void 0 : _b._id) !== null && _c !== void 0 ? _c : "",
                            order_number: (_f = (_e = (_d = checkoutBasket === null || checkoutBasket === void 0 ? void 0 : checkoutBasket.content) === null || _d === void 0 ? void 0 : _d.order) === null || _e === void 0 ? void 0 : _e.code) !== null && _f !== void 0 ? _f : "",
                            status: "AWAIT",
                            uid: loan_id,
                        }).then(function (response) {
                            if (response.success) {
                                window.scrollTo({
                                    top: 0,
                                    behavior: "smooth",
                                });
                                setIsLoading(false);
                                // dispatch(get_basket_thunk({ basket_id: basket?._id }));
                            }
                        })];
                case 2:
                    _g.sent();
                    _g.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    return (react_1.default.createElement("div", { className: "relative" }, isLoading ? (react_1.default.createElement(doshx_controls_web_1.ShimmerBoxControl, null)) : (react_1.default.createElement("div", { className: "relative" },
        react_1.default.createElement("div", { className: "" },
            react_1.default.createElement(doshx_controls_web_1.ScreenContainerControl, { className: "" },
                react_1.default.createElement("div", { className: "flex flex-col items-center py-20 gap-4" },
                    react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Completed", textColor: "text-white", size: "3xlarge", center: true }),
                    react_1.default.createElement("div", { className: "flex flex-col" },
                        react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "You have successfully applied for a loan. A response will be sent to you shortly.", textColor: "text-white", size: "medium", center: true }))),
                react_1.default.createElement("div", { className: " flex justify-center" },
                    react_1.default.createElement(doshx_controls_web_1.BoxControl, { className: "w-[400px] md:w-[400px] lg:w-[600px] shadow-sm shadow-[#9f9f9f] border-none", backgroundColor: "bg-white" },
                        react_1.default.createElement("div", { className: "flex flex-row justify-center text-primary" },
                            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faCheckCircle, size: "10x" })),
                        react_1.default.createElement("div", { className: "pt-8 flex flex-row justify-center" },
                            react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: "Home", backgroundColor: "bg-secondary", onClick: function () {
                                    navigate("/");
                                } })))))),
        react_1.default.createElement("div", { className: "absolute top-0 w-full -z-10" },
            react_1.default.createElement("div", { className: "h-72 bg-primary" }),
            react_1.default.createElement("div", { className: "-mt-[1px]" },
                react_1.default.createElement("svg", { viewBox: "0 0 20 1.5", xmlns: "http://www.w3.org/2000/svg" },
                    react_1.default.createElement("path", { d: "M 0 0 L 20 0 Q 10 3 0 0", fill: colors_config_1.default.primary })))),
        react_1.default.createElement(get_app_1.GetAppComponent, null),
        " "))));
};
exports.LoanApplicationComplete = LoanApplicationComplete;
